module.exports = __webpack_public_path__ + "img/ES-J-10.20c78d72.svg";